import clsx from 'clsx';

type IconProps = JSX.IntrinsicElements['svg'] & {
    direction?: 'up' | 'right' | 'down' | 'left';
  };

function Icon({
    children,
    className,
    fill = 'currentColor',
    stroke,
    ...props
}: IconProps) {
    return (
        <svg width="29" height="30" viewBox="0 0 29 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M25.7893 29.1709C25.1773 29.1709 24.6613 29.0539 24.2413 28.8199C23.8213 28.5859 23.5003 28.2589 23.2783 27.8389C23.0623 27.4129 22.9543 26.9149 22.9543 26.3449V22.4299H24.2323V26.4169C24.2323 26.7289 24.2923 27.0049 24.4123 27.2449C24.5323 27.4789 24.7063 27.6619 24.9343 27.7939C25.1683 27.9199 25.4533 27.9829 25.7893 27.9829C26.1193 27.9829 26.3983 27.9199 26.6263 27.7939C26.8603 27.6619 27.0343 27.4789 27.1483 27.2449C27.2683 27.0109 27.3283 26.7349 27.3283 26.4169V22.4299H28.6063V26.3449C28.6063 26.9149 28.4983 27.4129 28.2823 27.8389C28.0723 28.2589 27.7573 28.5859 27.3373 28.8199C26.9173 29.0539 26.4013 29.1709 25.7893 29.1709Z" fill="black"/>
        <path d="M15.0056 28.9999V22.4299H17.1026L19.8656 27.9379H20.1626L19.9826 28.0999V22.4299H21.1886V28.9999H19.0826L16.3196 23.4919H16.0136L16.1936 23.3299V28.9999H15.0056Z" fill="black"/>
        <path d="M9.37427 28.9999V22.4299H10.6253V28.9999H9.37427ZM10.4453 28.9999V27.9199H13.4243V28.9999H10.4453ZM10.4453 26.2009V25.1209H13.1903V26.2009H10.4453ZM10.4453 23.5099V22.4299H13.3523V23.5099H10.4453Z" fill="black"/>
        <path d="M0.517334 28.9999V22.4299H2.26333L3.91033 26.3539H4.07233L5.71033 22.4299H7.48333V28.9999H6.21433V23.3929L6.37633 23.4109L4.60333 27.6589H3.29833L1.51633 23.4109L1.68733 23.3929V28.9999H0.517334Z" fill="black"/>
        <rect x="3" width="21" height="2" fill="black"/>
        <rect x="3" y="6" width="21" height="2" fill="black"/>
        <rect x="3" y="12" width="21" height="2" fill="black"/>
        </svg>
        
    );
}

export default function MenuIcon(props: IconProps) {
    return (
      <Icon {...props} stroke={props.stroke || 'currentColor'}>
        <title>Menu</title>
        <line x1="3" y1="6.375" x2="17" y2="6.375" strokeWidth="1.25" />
        <line x1="3" y1="10.375" x2="17" y2="10.375" strokeWidth="1.25" />
        <line x1="3" y1="14.375" x2="17" y2="14.375" strokeWidth="1.25" />
      </Icon>
    );
  }